import { BLOCKS, MARKS } from "@contentful/rich-text-types";

export const documentToHtmlOptions = {
  renderNode: {
    [BLOCKS.LIST_ITEM]: (
      node: object,
      children:
        | string
        | number
        | boolean
        | React.ReactFragment
        | React.ReactPortal
        | React.ReactElement
        | null
        | undefined
    ) => <li key={`${Math.random()}`}>{children}</li>,
    [BLOCKS.PARAGRAPH]: (
      node: object,
      children:
        | string
        | number
        | boolean
        | React.ReactFragment
        | React.ReactPortal
        | React.ReactElement
        | null
        | undefined
    ) => <p key={`${Math.random()}`}>{children}</p>,
    [BLOCKS.EMBEDDED_ENTRY]: (node: any) => {
      switch (node.data.target.sys.contentType.sys.id) {
        // case 'ingredient': {
        //   const { ingredient_name, ingredient_image } = node.data.target.fields;
        //   return <Ingredient name={ingredient_name} image={ingredient_image} />
        // }
        default:
          return <div>Fallback Element</div>;
      }
    },
  },
  renderText: (text: any) =>
    text
      .split("\n")
      .flatMap((text: any, i: number) => [
        i > 0 && <br key={`${Math.random()}`} />,
        text,
      ]),
  renderMark: {
    [MARKS.BOLD]: (text: any) => {
      return <strong key={`${Math.random()}`}>{text}</strong>;
    },
  },
};
